import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getResourceAPI,
  getResourceStatus,
} from "../redux/slices/resourceSlice";

const useFetch = ({ resourceName, path }) => {
  const dispatch = useDispatch();

  const status = useSelector((status) =>
    getResourceStatus(status, `${resourceName}Status`)
  );

  useEffect(() => {
    status === "idle" && dispatch(getResourceAPI({ path }));
  }, [dispatch, status, resourceName, path]);
};

export default useFetch;
